module.exports = __webpack_public_path__ + "img/more-info-srd.b91fb9e6.svg";